import React, { ComponentType } from 'react';
import { pressableClass } from '@bit/bit.gui.effects.pressable';
import classnames from 'classnames';

import { ButtonProps } from '../base-button';

import styles from './genesis-button.module.scss';

export const GenesisCtaFlavor = (WrappedComponent: ComponentType<ButtonProps>) => (
	props: ButtonProps
) => {
	return (
		<WrappedComponent
			{...props}
			className={classnames(pressableClass, styles.genesisCta, props.className)}
		/>
	);
};

export const GenesisFlavor = (WrappedComponent: ComponentType<ButtonProps>) => (
	props: ButtonProps
) => {
	return (
		<WrappedComponent
			{...props}
			className={classnames(pressableClass, styles.genesisButton, props.className)}
		/>
	);
};
